import './index.css'

import { Theme } from '@radix-ui/themes'
import React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import type { Location } from 'react-router-dom'
import { Link } from 'react-router-dom'

import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'

import type { Recipient } from 'types/list'
import type { Playlist } from 'types/playlist'

import { Flex } from 'components/ds'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import modalStyles from 'components/utils/modalStyles'

class SendPlaylistConfirmation extends React.Component<
  {
    onClose: (...args: Array<any>) => any
    sendMixpanelEvent: typeof sendMixpanelEvent
    onShareAgain: (...args: Array<any>) => any
    recipients: Recipient[]
    playlist?: Playlist
    shortlist?: Playlist
    location: Location
    newEmailGroupRoute: string
  },
  {
    showGroupModal: boolean
    showGroupCreatedNotification: boolean
    groupName: string | null | undefined
  }
> {
  state = {
    showGroupModal: false,
    showGroupCreatedNotification: false,
    groupName: null,
  }
  _createGroupModal = () => {
    this.setState({
      showGroupModal: true,
    })
  }
  _completeGroup = (groupName: string) => {
    this.props.sendMixpanelEvent('Create email group via share modal')
    this.setState({
      showGroupModal: false,
      showGroupCreatedNotification: true,
      groupName: groupName,
    })
  }

  _statsUrl() {
    let playlistId

    if (this.props.playlist) {
      playlistId = this.props.playlist.playlist_id
    } else if (this.props.shortlist) {
      playlistId = this.props.shortlist.playlist_id
    }

    const returnPath = this.props.location?.pathname ?? '/'
    return `/explorer/playlists/${playlistId}/stats?return=${returnPath}`
  }

  _groupName() {
    const searchParams = new URLSearchParams(this.props.location?.search)
    const queryGroupName = searchParams.get('emailGroup') ?? undefined
    return this.state.groupName || queryGroupName
  }

  _renderSuccessMessage() {
    const groupName = this._groupName()

    if (this.state.showGroupCreatedNotification || groupName) {
      // show nothing - only "well done! group created"
      return null
    }

    const accessStatisticsLink = (
      <Link className="SendPlaylistConfirmation_Link" to={this._statsUrl()}>
        access statistics here
      </Link>
    )
    return (
      <div className="SendPlaylistConfirmation_Text">
        Your recipients will receive an email shortly! You can check{' '}
        {accessStatisticsLink}.
      </div>
    )
  }

  _renderGroupNotification() {
    const groupName = this._groupName()

    const showNotification =
      this.props.recipients.filter(r => r.type !== 'business').length > 1

    if (showNotification && !groupName) {
      const textLink = (
        <Link
          className="SendPlaylistConfirmation_Link"
          to={this.props.newEmailGroupRoute}
        >
          you can do that too
        </Link>
      )
      return (
        <div>
          <div className="SendPlaylistConfirmation_Text">
            If you’d like to create a mailing list out of these users to save
            time sending to them next time, {textLink}.
          </div>
        </div>
      )
    } else if (this.state.showGroupCreatedNotification || groupName) {
      return (
        <div className="SendPlaylistConfirmation_Text">
          Well done! Your new mailing list <b>Supervisors</b> has been created.
          You can manage it{' '}
          <span
            style={{
              whiteSpace: 'nowrap',
            }}
          >
            in the new Mailing Lists
          </span>
          .
        </div>
      )
    }

    return null
  }

  render() {
    return (
      <Modal onRequestClose={this.props.onClose} isOpen style={modalStyles}>
        <Theme>
          <div className="PlaylistSendConfirmationForm">
            <h1 className="Form_Header is-centred">Playlist Sent!</h1>
            {this._renderSuccessMessage()}
            {this._renderGroupNotification()}
            <Flex direction="column" align="center" mt="4">
              <ButtonContainer centered>
                <Button
                  appearance="primary"
                  caption="Share again"
                  onClick={this.props.onShareAgain}
                />
                <Button caption="Close" onClick={this.props.onClose} />
              </ButtonContainer>
            </Flex>
          </div>
        </Theme>
      </Modal>
    )
  }
}

export default connect(null, {
  sendMixpanelEvent,
})(SendPlaylistConfirmation) as any
